import { T } from '@tribeplatform/react-components/i18n'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export function ArchivedCMSRootTreeItem() {
  return (
    <div className="flex items-center gap-2 py-2">
      <SvgIcon name="customizer" />
      <T defaultMessage="Archived models" id="Admin.CMS.Model.ArchivedModels" />
    </div>
  )
}
